import initContact from '../contact';

export default {
  init() {
    initContact()
    const a = $('header').find('li').last().find('a');
    const href = a.attr('href');
    a.attr('href', window.location.href + href.substring(1, href.length));
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/services.js